import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.filter";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { getDisplayName as getName, getImageAltText, getImageSrc } from '@nerdwallet/marketplace/selectors/common';
import { isNonMonetizing } from '@nerdwallet/marketplace/utils';
import ContentSanitizer from '../content-sanitizer';
export var buildTrkSectionCategory = function buildTrkSectionCategory() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(Boolean).join('__');
};
export var getImageData = function getImageData(marketplaceEntity) {
  var srcSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    src: getImageSrc(marketplaceEntity, srcSize),
    alt: getImageAltText(marketplaceEntity) || getName(marketplaceEntity)
  };
}; // Check against type 'string' to match the underlying
// html-react-parser lib. Additionally, this ensures we render both
// single React elements as well as arrays of React elements.
// Additional param propertyThatUsesHttp used to override anchor element in content-sanitizer
// @see https://github.com/remarkablemark/html-react-parser/blob/master/index.js#L16

export var sanitizeNode = function sanitizeNode(node) {
  var respectUnsafeHref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return typeof node !== 'string' ? node : /*#__PURE__*/React.createElement(ContentSanitizer, {
    html: node,
    respectUnsafeHref: respectUnsafeHref
  });
}; // This is the string constant used to represent showing the default drivers
// for a given product.

export var DEFAULT_DRIVER_GROUP = 'DEFAULT_DRIVER_GROUP'; // Gets the drivers to use based off a config object, an optional driver group name,
// and any other props passed to the config functions.  It tries to fallback to
// any declared default configuration, then if it still can't find it, to no drivers.

export var getDrivers = function getDrivers(_ref) {
  var driverGroupConfig = _ref.driverGroupConfig,
      driverGroup = _ref.driverGroup,
      props = _objectWithoutProperties(_ref, ["driverGroupConfig", "driverGroup"]);

  if (_typeof(driverGroupConfig) === 'object') {
    var specificGroupGenerator = driverGroupConfig[driverGroup];

    if (typeof specificGroupGenerator === 'function') {
      return specificGroupGenerator(props);
    }

    var defaultGroupGenerator = driverGroupConfig[DEFAULT_DRIVER_GROUP];

    if (typeof defaultGroupGenerator === 'function') {
      return defaultGroupGenerator(props);
    }
  }

  return {};
};
export var buildAnalyticsEntityName = function buildAnalyticsEntityName(entityName) {
  return entityName === null || entityName === void 0 ? void 0 : entityName.toLowerCase().replace(/ |\W/g, '_').substring(0, 64);
};
/**
 *
 * @param {Object} marketplaceEntity  the marketplace entity object
 *
 * @return {String}   the expected shopping finished event monetizable string
 * One of 'yes_assumed',
 *        'no',
 *        'no_because_of_limit',
 *        'no_because_of_lead',
 */

export var getMonetizable = function getMonetizable(marketplaceEntity) {
  return isNonMonetizing(marketplaceEntity) ? 'no' : 'yes_assumed';
};